import APIconsume from 'Main/APIconsume'
import { minPageSizeConfigs } from 'Main/Utils'

const BASE_URL = '/api/dashboard/global-callback-logs'

class GlobalCallbackLogsService {
  constructor () {
    this._apiConsume = new APIconsume()
  }

  /**
   * GET /vendors/global-callback-logs: replaces the server-rendered
   * GET /dashboard/global-callback-logs query-string filtering from
   * globalCallbackLogs.ejs.
   */
  async getData ({
    page = 1,
    size = minPageSizeConfigs,
    endpoint = '%',
    status = '%',
    type = '%',
    paymentVendorsId = '',
    qrisExtConfigsId = '',
    from = '',
    to = '',
    userId = 'ALL'
  } = {}) {
    const params = new URLSearchParams({
      page,
      size,
      endpoint,
      status,
      type,
      payment_vendors_id: paymentVendorsId,
      qris_ext_configs_id: qrisExtConfigsId,
      from,
      to,
      user_id: userId
    }).toString()

    const result = await this._apiConsume.getData(`${BASE_URL}?${params}`)
    return result?.data
  }

  /**
   * GET /vendors/global-callback-logs/filters: one call to back every filter dropdown.
   */
  async getFilters (userId = 'ALL') {
    const params = new URLSearchParams({ user_id: userId }).toString()
    const result = await this._apiConsume.getData(`${BASE_URL}/filters?${params}`)
    return result?.data
  }

  /** GET /vendors/global-callback-logs/:id */
  async getById (id) {
    const result = await this._apiConsume.getData(`${BASE_URL}/${id}`)
    return result?.data
  }

  /** Payment callbacks are read-only; resend is their only dashboard action. */
  async resend (id) {
    const result = await this._apiConsume.postData({ id }, `${BASE_URL}/resend`)
    return result?.data
  }
}

export default GlobalCallbackLogsService
